import React, { useState } from 'react';

import {
	FullPageEditorLoader,
	TreeRootForServerPlaceholderWrapper,
} from '@confluence/full-page-editor';
import { FullCycleRender } from '@confluence/ssr-utilities';
import { getApolloClient } from '@confluence/graphql';
import type { NativeCollabQueryResponse } from '@confluence/native-collab';
import { NativeCollabQuery } from '@confluence/native-collab';

type EditPageLoaderServerProps = {
	contentId: string;
	spaceKey: string;
	draftShareId?: string;
	contentType: string;
};

// This component is supposed to be server-side version of EditPageLoader and will be used
// for rendering content area / breadcrumbs and possibly editor toolbar, i.e. anything being
// rendered by FullPageEditorLoader. At the current stage we skip server-rendering of content
// area so the component is empty.
export const EditPageLoaderServer = ({
	contentId,
	spaceKey,
	draftShareId,
	contentType,
}: EditPageLoaderServerProps) => {
	const [isUnpublishedDraft, setIsUnpublishedDraft] = useState(false);

	void (async () => {
		const queryResult = await getApolloClient().query<NativeCollabQueryResponse>({
			query: NativeCollabQuery,
			variables: {
				contentId,
				status: ['draft', 'current'],
				...(draftShareId && { draftShareId }),
			},
			fetchPolicy: 'cache-first',
			context: { single: 'true' },
		});
		const isUnpublishedDraft = !queryResult.data?.content?.nodes?.[0]?.history?.createdBy;
		setIsUnpublishedDraft(isUnpublishedDraft);
	})();

	return (
		<FullCycleRender name="edit-page">
			<TreeRootForServerPlaceholderWrapper>
				<FullPageEditorLoader
					isUnpublishedDraft={isUnpublishedDraft}
					contentId={contentId}
					spaceKey={spaceKey}
					draftShareId={draftShareId}
					contentType={contentType}
					collabEditState={{}}
					heartbeatData={{}}
					disabled
				/>
			</TreeRootForServerPlaceholderWrapper>
		</FullCycleRender>
	);
};
